// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ansifg-b {
  color: #000000;
}

.ansifg-r {
  color: #FF6673;
}

.ansifg-g {
  color: #73E68C;
}

.ansifg-y {
  color: #FEFB84;
}

.ansifg-bl {
  color: #66BDFF;
}

.ansifg-m {
  color: #AE99FF;
}

.ansifg-c {
  color: #66E0FF;
}

.ansifg-w {
  color: #FFFFFF;
}

.ansifg-gr {
  color: #A6A6A6;
}

.ansibg-b {
  background-color: #000000;
}

.ansibg-r {
  background-color: #FF6673;
}

.ansibg-g {
  background-color: #73E68C;
}

.ansibg-y {
  background-color: #FEFB84;
}

.ansibg-bl {
  background-color: #000000;
}

.ansibg-m {
  background-color: #AE99FF;
}

.ansibg-c {
  background-color: #66E0FF;
}

.ansibg-w {
  background-color: #FFFFFF;
}

.ansibg-gr {
  background-color: #A6A6A6;
}

.bright {
  filter: brightness(1.5);
}

/*# sourceMappingURL=Ansi.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-pipelines-ui/src/Components/LogViewer/Ansi.scss","webpack://./../azure-pipelines-ui/bin/Components/LogViewer/Ansi.css"],"names":[],"mappings":"AAYA;EACI,cAZS;ACCb;;ADaA;EACI,cAdO;ACIX;;ADYA;EACI,cAhBQ;ACOZ;;ADWA;EACI,cAlBU;ACUd;;ADUA;EACI,cApBO;ACaX;;ADSA;EACI,cAtBU;ACgBd;;ADQA;EACI,cAxBO;ACmBX;;ADOA;EACI,cA1BQ;ACsBZ;;ADMA;EACI,cA5BO;ACyBX;;ADOA;EACI,yBAzCS;ACqCb;;ADMA;EACI,yBA3CO;ACwCX;;ADKA;EACI,yBA7CQ;AC2CZ;;ADIA;EACI,yBA/CU;AC8Cd;;ADGA;EACI,yBArDS;ACqDb;;ADEA;EACI,yBAnDU;ACoDd;;ADCA;EACI,yBArDO;ACuDX;;ADAA;EACI,yBAvDQ;AC0DZ;;ADDA;EACI,yBAzDO;AC6DX;;ADDA;EACI,uBAAA;ACIJ;;AAEA,mCAAmC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
